module.exports = __webpack_public_path__ + "img/hm.18887169.png";